import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/portal/api/d2c-auto-quote-tool-msrv';
  // rootUrl: string = '//localhost:8085/d2c-auto-quote-tool-msrv';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
